import SnpShape from "./SnpShape";

const SNP_SPACING = 12;

export default function GeneSnpShapes({ id, groupId, genePalette, startX, startY, snpCount }) {
  if (!snpCount) return null;

  return (
    <g id={groupId}>
      {Array.from({ length: snpCount }, (_, index) => (
        <SnpShape
          key={`${id}-snp-${index}`}
          id={`${id}-snp-${index + 1}`}
          x={startX + index * SNP_SPACING}
          y={startY}
          symbol={genePalette.getSnpSymbol(index)}
          fill={genePalette.getSnpFill(index)}
        />
      ))}
    </g>
  );
}
